module.exports = __webpack_public_path__ + "static/hole_front-dbdb86fdd3d98f23f4402e85614f8a63.png";